<template>
  <div>
     <div v-if="submit_loader" style="position:absolute; top:0; right:0; bottom:0; left:0; padding-top: 25%;background-color:rgba(255, 255, 255, 0.31)">
          <div class="text-xs-center">
            <v-progress-circular
                :size="70"
                :width="7"
                indeterminate
                color="#ff9233"
                class="text-xs-center my-5"
                large
            ></v-progress-circular>
          </div>
      </div> 
    <v-container fluid grid-list-md class="padding_10" v-else>
      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12 sm8 md8 class="text-xs-left">
          <!-- <h2>Create Workspace</h2> -->
        </v-flex>
      </v-layout>
      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12>
          <v-card>
            <v-form
              id="createContact"
              @submit.prevent="validateBeforeSubmit('createContact')"
              data-vv-scope="createContact"
              v-model="valid"
            >
              <v-card-text>
                <v-container
                  fluid
                  grid-list-md
                  style="padding: 0px 0px 0px 0px"
                >
                  <v-layout row wrap>
                    <v-flex xs6 sm2>
                      <label>Category: </label>
                    </v-flex>
                    <v-flex xs6 sm3>
                      <v-autocomplete
                        label="Select Category"
                        name="Category"
                        :items="contact_category"
                        v-model="contact_object.category"
                        return-object
                        item-text="name"
                        item-value="id"
                        selected
                        v-validate="'required'"
                        :error-messages="
                          errors.collect('createContact.Category')
                        "
                        clearable
                      >
                      </v-autocomplete>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs6 sm2>
                      <label>Title: </label>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        name="title"
                        v-model="contact_object.title"
                        label="Title"
                         v-validate="'required'"
                        :error-messages="
                          errors.collect('createContact.title')
                        "
                        clearable
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                   <v-layout row wrap>
                    <v-flex xs6 sm2>
                      <label>Description: </label>
                    </v-flex>
                    <v-flex xs6>
                      <v-textarea
                        name="description"
                        v-model="contact_object.description"
                        clearable
                      ></v-textarea>
                      
                    </v-flex>
                  </v-layout>
                   <v-layout row wrap>
                    <v-flex xs6 sm2>
                      <label>Contact Info: </label>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        name="contact_info"
                        v-model="contact_object.contact_info"
                        label="Contact Info"
                         v-validate="'required'"
                        :error-messages="
                          errors.collect('createContact.contact_info')
                        "
                        clearable
                      ></v-text-field>
                       
                    </v-flex>
                  </v-layout> 
                   <v-layout row wrap>
                    <v-flex xs6 sm2>
                      <label>Ref Links: </label>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        name="ref_link"
                        v-model="contact_object.ref_link"
                        label="refer Link"
                        clearable
                      ></v-text-field>
                       
                    </v-flex>
                  </v-layout> 
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" small :disabled="!valid" type="submit"
                  >create
                </v-btn>
                <v-btn flat small to="/contact-list">Cancel</v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-flex>
      </v-layout>
      <v-snackbar
        :color="snackBar.color"
        :top="snackBar.top"
        :bottom="snackBar.bottom"
        :left="snackBar.left"
        :right="snackBar.right"
        v-model="snackBar.show"
      >
        {{ snackBar.message }}
        <v-btn dark flat @click.native="snackBar.show = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>



<script>
import moment from "moment";
import { VueEditor } from "vue2-editor";

export default {
  name: "Create",
  components: {
    VueEditor,
  },
  data: () => {
    return {
     contact_object:{
       category:"",
       title:"",
       description:"",
       contact_info:"",
       ref_link:"",
       
     },
      contact_category:[],
      submit_loader: false,
      valid:false,
      snackBar: {
        show: false,
        color: "",
        message: "",
        top: true,
        right: true,
        bottom: false,
        left: false,
      },
    };
  },
 

  methods: {
  

    validateBeforeSubmit: function (scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this[scope]();
        }
      });
    },
    createContact: function () {
      this.submit_loader = true;
      let new_contact_details = Object.assign({}, this.contact_object);
      new_contact_details.category_id = this.contact_object.category.id;

      axios
        .post(
          `${process.env.VUE_APP_API_URL}/api/v1/store-emergency-contact`,new_contact_details,
           { headers: this.$headers }
        )
       
        .then((response) => {
          if (response.data.status == 1) {
           

            this.submit_loader = true;
            this.snackBar.show = true;
            this.snackBar.message = response.data.message;
            this.contact_object = '';
            // this.$router.push({name:"Ecart-Booking-list"});  
          } else {
       
            this.snackBar.message = response.data.message;
            this.snackBar.show = true;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.submit_loader = false;
        });
    },
    getContactCategory: function(){

       axios
            .get(`${process.env.VUE_APP_API_URL}/api/v1/emergency-contact-category`,{headers:this.$headers})
            .then(response => {
              if (response.data.status == 1)
              { 
                this.contact_category = response.data.contact_category;
             }  
        })
    }
  },
   mounted(){
      this.getContactCategory();
  },
};
</script>

<style type="text/css">
  .accent--text {
    color: #f67656;
    caret-color: #383859;
}
</style>

